import { type UnifiedJobSearchScheme } from './utils';

/**
 * The phone filter sheet's panels: the desktop form's controls, grouped as a technician looks
 * for a job. Every control is in exactly one panel; the global search box is outside the sheet.
 */
export const JOB_SEARCH_SECTIONS = [
  {
    id: 'statusType',
    label: 'Status and type',
    fields: [
      'jobStatus',
      'projectsOnly',
      'serviceCallsOnly',
      'jobTypeId',
      'jobSubtypeId',
      'isResidential',
    ],
  },
  {
    id: 'assignment',
    label: 'Technician and department',
    fields: ['technicianAssigned', 'departmentId'],
  },
  {
    id: 'dates',
    label: 'Dates',
    fields: ['dateStartedFrom', 'dateStartedTo', 'dateEndedFrom', 'dateEndedTo'],
  },
  { id: 'customer', label: 'Customer', fields: ['firstName', 'lastName', 'businessName'] },
  { id: 'property', label: 'Property', fields: ['propertyAddress', 'city', 'state', 'zip'] },
  {
    id: 'details',
    label: 'Job details',
    fields: ['jobNumber', 'poNumber', 'name', 'servicesNeeded', 'logNotes'],
  },
] as const satisfies ReadonlyArray<{
  id: string;
  label: string;
  fields: ReadonlyArray<keyof UnifiedJobSearchScheme>;
}>;

export type JobSearchSectionId = (typeof JOB_SEARCH_SECTIONS)[number]['id'];
